import { createTheme } from "@mui/material";
import palette from "./palette";
import typography from "./typography";
import components from "./overrides";

const baseTheme = {
	palette,
	typography,
	components,
};

export const theme = createTheme(baseTheme);
export const themeWithRtl = createTheme({ ...baseTheme, direction: "rtl" });
